import EventEmitter from 'eventemitter3';

const emitter = new EventEmitter();

const Event = {
	SUCCESS: 'success',
	ERROR: 'error',
	WARNING: 'warning',
	LIVE: 'live',
};

/**
 * Event Listeners
 */
export const onSuccessEvent = (cb: EventEmitter.ListenerFn) => {
	emitter.on(Event.SUCCESS, cb);
};

export const onErrorEvent = (cb: EventEmitter.ListenerFn) => {
	emitter.on(Event.ERROR, cb);
};

export const onInfoEvent = (cb: EventEmitter.ListenerFn) => {
	emitter.on(Event.WARNING, cb);
};

export const onLiveEvent = (cb: EventEmitter.ListenerFn) => {
	emitter.on(Event.LIVE, cb);
};

export const removeListeners = () => {
	emitter.off(Event.SUCCESS);
	emitter.off(Event.ERROR);
	emitter.off(Event.WARNING);
	emitter.off(Event.LIVE);
};

/**
 * Event Emitters
 */

export const showSuccess = (
	message: string | JSX.Element,
	onClose?: () => any
) => {
	emitter.emit(Event.SUCCESS, message, onClose);
};

export const showError = (
	message: string | JSX.Element,
	onClose?: () => any
) => {
	emitter.emit(Event.ERROR, message, onClose);
};

export const showInfo = (
	message: string | JSX.Element,
	onClose?: () => any
) => {
	emitter.emit(Event.WARNING, message, onClose);
};

export const showLiveInfo = (message: string) => {
	emitter.emit(Event.LIVE, message);
};
